import mainAmazon from "./img/amazonImg.png";
import mainStrawberry from "./img/strawberry.png";
import logo from "./img/logo.png"
import play from "./img/button-play.png"
import supportImg from "./img/localimg.png"
import supportImgSecond from "./img/localimg1.png";
import supportImgItem from "./img/localimg2.png";
import supportCircle from "./img/supportBack.png";
import stepIndicatorImg from "./img/step4ell.png";
import stepImgFirst from "./img/imgcard1.png";
import stepDelivery from "./img/delivery.png";
import stepImgCard from "./img/imgcard.png";
import step2ell from "./img/step2ell.png";
import stepImg4 from "./img/stepimg4.png";
import stepCircle from "./img/circleeasy.png";
import stepImg3 from "./img/steimg3.png";
import easyCircle from "./img/circleeasy.png";
import easyEllipse from "./img/ellipsered.png";
import easyEllipse1 from "./img/circleeasy1.png";
import easyImg from "./img/easyimg.png";
import amazonImg from "./img/amazonback.png"
import tariffImg from "./img/tarifimg.png";
import tariffImg2 from "./img/tarifimg.png";
import tariffPatern from "./img/Pattern.png";
import tariffCheck from "./img/Check1.png"
import tariffCheckImg from "./img/Check.png";
import succsesImg from "./img/elipsesuccses.png";
import succsesImgLeft from "./img/arrowleft.png";
import succsesRight from "./img/arrowright.png";
import succsesBtn from "./img/successbtnimg.png";
import teamImgEllipse from "./img/ellipseteam.png";
import teamImgCircle from "./img/circleteam.png";
import teamGirlImg from "./img/girl2.png"
import teamGirlImg2 from "./img/girl1.png";
import teamGirlImg3 from "./img/girl3.png";
import teamCircleImg from "./img/circleteam1.png";
import teamImgBack from "./img/teamimg.png";
import teamActive from "./img/teamactive.png";
import contactImg from "./img/contactimg.png";
import contactImg2 from "./img/contactimg2.png"
import contactImg3 from "./img/contactimg1.png";
import sliderShape from "./img/shape.png";
import sliderUser from "./img/userSlider.png";
import sliderLeft from "./img/arrowleft.png";
import sliderRight from "./img/arrowright.png"
import subscribeBack from "./img/subback.png";
import subscribeEllipse from "./img/ellipsesub.png";
import subscribePolygon from "./img/polygon.png";
import dashboardImg from "./img/Data.png";
import dashboardImg1 from './img/productimg1.png'
import dashboardImg2 from './img/productimg2.png'
import dashboardImg3 from './img/productimg3.png'
import dashboardPlyus from "./img/plus.png";
import footerLogo from "./img/logo.png"
import footerApple from "./img/apple.png";
import footerUps from "./img/ups.png";
import footerAmazon from "./img/amazon.png";
import footerDhl from "./img/dhl.png";
import footerFedex from "./img/fedex.png";
import helpDefault from "./img/default.png";
import helpChart from "./img/chart.png"
import helpDefault1 from "./img/default4.png";
import helpDefault2 from "./img/default3.png"
import helpDefault3 from "./img/default2.png";
import helpOut from "./img/outline.png";
import helpDefault4 from "./img/default1.png";
import helpCircle from "./img/circle.png";
import productPlyus from "./img/plus.png";
import loginAlarm from "./img/alarm.png";
import loginEllipse from "./img/ellipseLogins.png"
import loginAbstract from "./img/abstract.png"
import amazonItemImg from './img/amazonimg5.png'
import amazonItemImg2 from  './img/amazonimg6.png'
import amazonItemImg3 from './img/amazonimg7.png'
import succsesim1 from './img/succsesim1.png'
import succsesim2 from './img/succsesim2.png'
import succsesimg from './img/4 308.png'
import logout from "./img/logoutt.png"

export const Image = {
    amazonItemImg3,
    amazonItemImg2,
    succsesimg,
    succsesim2,
    succsesim1,
    amazonItemImg,
    logo,
    mainStrawberry,
    mainAmazon,
    play,
    supportImg,
    supportImgSecond,
    supportImgItem,
    supportCircle,
    stepIndicatorImg,
    stepImgFirst,
    stepDelivery,
    stepImgCard,
    step2ell,
    stepImg4,
    stepCircle,
    stepImg3,
    easyCircle,
    easyEllipse,
    easyEllipse1,
    easyImg,
    amazonImg,
    tariffImg,
    tariffImg2,
    tariffPatern,
    tariffCheck,
    tariffCheckImg,
    succsesImg,
    succsesImgLeft,
    succsesRight,
    succsesBtn,
    teamImgEllipse,
    teamImgCircle,
    teamGirlImg,
    teamGirlImg2,
    teamGirlImg3,
    teamCircleImg,
    teamImgBack,
    teamActive,
    contactImg,
    contactImg2,
    contactImg3,
    sliderShape,
    sliderUser,
    sliderLeft,
    sliderRight,
    subscribeBack,
    subscribeEllipse,
    subscribePolygon,
    dashboardImg,
    dashboardImg1,
    dashboardImg2,
    dashboardImg3,
    dashboardPlyus,
    footerLogo,
    footerApple,
    footerUps,
    footerAmazon,
    footerDhl,
    footerFedex,
    helpDefault,
    helpChart,
    helpDefault1,
    helpDefault2,
    helpDefault3,
    helpOut,
    helpDefault4,
    helpCircle,
    productPlyus,
    loginAlarm,
    loginEllipse,
    loginAbstract,
    logout
}